export enum ERC20Contracts {
  DunkNFT = "DunkNFT",
  DUNKPLATFORM = "DUNKPLATFORM",
  DUNKToken = "DUNKToken",
}
